<template>
    <section class="changelog">
        <template v-if="changes.html">
            <div v-html="changes.html" />
        </template>
        <template v-else>
            <CenteredMessage :spinner="true">Lädt Neuerungsansicht...</CenteredMessage>
        </template>
    </section>
</template>

<script>
// import { ApiFactory } from "@/api/ApiFactory.js";
import ChangelogApi from "@/api/ChangelogApi";
import CommonView from "@/mixins/CommonView/CommonView";
import CenteredMessage from "@/components/CenteredMessage/CenteredMessage";

import showdown from "showdown";

const converter = new showdown.Converter();

export default {
    name: "Changelog",
    components: {
        CenteredMessage
    },
    mixins: [CommonView],
    data() {
        return {
            version: null,
            changes: {
                raw: null,
                html: null
            },
            api: ChangelogApi
        };
    },
    methods: {
        async fetch() {
            this.busy = true;
            const response = await this.api.get();
            if (response.ok) {
                const text = response.text;
                const html = converter.makeHtml(text);

                this.changes = {
                    raw: text,
                    html: html
                };
            }
            this.busy = false;
        }
    }
};
</script>